import messageResource from "../../messageResource";
import HierarchySelectorUtil from "../../controls/selectorControls/hierarchy_selector_util";
import TwoLevelSelection from "../../controls/selectorControls/two_level_selection";
import TreeNode from "../../hierarchySelector/tree/TreeNode";

export default function UserSelectorGroupsStrategy() {

}


UserSelectorGroupsStrategy.prototype.getEmptySelectionTooltipText = function() {
    return messageResource.getEscapedMessage(this.emptySelectionTooltipTextKey);
};

UserSelectorGroupsStrategy.prototype.getNoNodesMatchingSearchMessage = function() {
    return messageResource.getEscapedMessage(this.noNodesMatchingSearchMessageKey);
};

UserSelectorGroupsStrategy.prototype.getNoSelectedNodesMessage = function() {
    return messageResource.getEscapedMessage(this.noSelectedNodesMessageKey);
};

UserSelectorGroupsStrategy.prototype.canExpandCollapseNodes = function() {
    //abstract
};

UserSelectorGroupsStrategy.prototype.createTree = function(rootNode, emptyMessageBuilder, collapsedNodeIds) {
    //abstract
};

UserSelectorGroupsStrategy.prototype.isGroupNodeRendererNeeded = function() {
    //abstract
};

UserSelectorGroupsStrategy.prototype.makeSelectionFromNodeSet = function(nodeSet, isFullFormed, mapFirstLevelToSecond) {
    var mapping = {};
    if (!mapFirstLevelToSecond)
        mapping[TreeNode.TYPE_GROUP] = TwoLevelSelection.FIRST_LEVEL_INDEX;
    mapping[TreeNode.TYPE_USER] = TwoLevelSelection.SECOND_LEVEL_INDEX;
    return HierarchySelectorUtil.makeSelectionFromNodeSet(nodeSet, isFullFormed, mapping, 3);
};

UserSelectorGroupsStrategy.prototype.makeOnlyUsersSelection = function(nodeSet) {
    return this.makeSelectionFromNodeSet(nodeSet, true, false).getSecondLevel();
};

UserSelectorGroupsStrategy.prototype.makeAllSelectedUsersSelection = function(nodeSet, tree, includeHiddenNodes) {
    //abstract
};

UserSelectorGroupsStrategy.prototype.isUserGroupNodeLevel = function(treeNode) {
    return treeNode.getType() == TreeNode.TYPE_GROUP
};

UserSelectorGroupsStrategy.prototype.isUserNodeLevel = function(treeNode) {
    return treeNode.getType() == TreeNode.TYPE_USER
};

UserSelectorGroupsStrategy.prototype.saveCollapsedNodesIntoCookies = function(tree, cookiesKey) {
    //abstract
};

UserSelectorGroupsStrategy.prototype.makeNodeSet = function(selection, rootNode) {
    //abstract
};

UserSelectorGroupsStrategy.prototype.getAdditionalTreePanelClasses = function() {
    return [];
};

UserSelectorGroupsStrategy.prototype.getUserNodeLevel = function () {
    //abstract
};



// WEBPACK FOOTER //
// ./web/js/usersSelector/userSelectorGroupsStrategies/UserSelectorGroupsStrategy.js